export default __webpack_public_path__ + "static/media/hello.fda1f185.jpg";